import React, { useState } from "react";
import "./header.css";
import BlueButton from "./BlueButton";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleScroll = (id) => {
    let scrollTimeout;

    const scrollToElement = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    };

    if (location.pathname !== "/") {
      navigate("/", { replace: true });
      scrollTimeout = setTimeout(() => {
        scrollToElement();
      }, 1000);

      return () => clearTimeout(scrollTimeout);
    } else {
      scrollToElement();
    }
  };

  return (
    <header className="header-container">
      <div className="befiscname">
        <img
          src="/images/leftwing.png"
          width={15}
          height={15}
          alt="leftwing"
          className="desktop-view-header"
          loading="lazy"
        />
        <span>
          BeFiSc wins the <br className="mobile-header-br" />
          <span style={{ color: "#B6FF00" }}>
            Fintech Innovation of the Year{" "}
          </span>
          Award 🎉
        </span>
        <img
          src="/images/bwimage.png"
          alt="bwimage"
          style={{ width: "6rem" }}
          className="desktop-header-images"
          loading="lazy"
        />
        <img
          src="/images/rightwing.png"
          width={15}
          height={15}
          alt="rightwing"
          className="desktop-header-images"
          loading="lazy"
        />
        <div className="mobile-view-header-images">
          <img
            src="/images/leftwing.png"
            width={15}
            height={15}
            alt="leftwing"
            className="mobile-view-header"
            loading="lazy"
          />
          <img
            src="/images/bwimage.png"
            alt="bwimage"
            style={{ width: "6rem" }}
            loading="lazy"
          />
          <img
            src="/images/rightwing.png"
            width={15}
            height={15}
            alt="rightwing"
            loading="lazy"
          />
        </div>
      </div>

      <nav className="header-navbar">
        <Link to={"/"}>
          <img
            src="/images/befiscsymbol.png"
            alt="befisc"
            className="logo"
            loading="lazy"
          />
        </Link>

        <div
          className="hamburger-icon"
          onClick={toggleMenu}
          aria-label="Toggle Menu"
        >
          {isOpen ? (
            <IoMdClose size={25} color="#000" />
          ) : (
            <GiHamburgerMenu size={25} color="#000" />
          )}
        </div>

        <ul className={`mobile-nav-list ${isOpen && "inview"}`}>
          <li>
            <a
              href="#product-click"
              onClick={() => handleScroll("product-click")}
            >
              Product
            </a>
          </li>
          {/* <li>
            <a
              href="#about-us-click"
              onClick={() => handleScroll("about-us-click")}
            >
              About Us
            </a>
          </li> */}
          <li>
            <a
              href="https://takh7ucwgg0.typeform.com/to/kG2iZbDL?typeform-source=www.linkedin.com"
              target="_blank"
              rel="noreferrer"
            >
              Newsletter
            </a>
          </li>
          {/* <li>
            <a
              href="#careers-click"
              onClick={() => handleScroll("careers-click")}
            >
              Careers
            </a>
          </li> */}
        </ul>

        <ul className={`nav-list`}>
          <li>
            <a
              href="#product-click"
              onClick={() => handleScroll("product-click")}
            >
              Product
            </a>
          </li>

          {/* <li>
            <a
              href="#about-us-click"
              onClick={() => handleScroll("about-us-click")}
            >
              About Us
            </a>
          </li> */}
          <li>
            <a
              href="https://takh7ucwgg0.typeform.com/to/kG2iZbDL?typeform-source=www.linkedin.com"
              target="_blank"
              rel="noreferrer"
            >
              Newsletter
            </a>
          </li>
          {/* <li>
            <a
              href="#careers-click"
              onClick={() => handleScroll("careers-click")}
            >
              Careers
            </a>
          </li> */}
        </ul>

        <div className="desktop-demo-button">
          <BlueButton
            text="Book a Demo"
            onClick={() => handleScroll("book-a-demo")}
          />
        </div>
      </nav>
    </header>
  );
}

export default Header;
